import { IS_AUTO_TEST_HIDE, IS_PHONE_BROWSER, IS_REACT_PAGE } from 'reactApp/appHelpers/configHelpers';
import { initWhatsNewPromo } from 'reactApp/modules/promo/sagas/whatsNew.saga';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { cancel, delay, put, select, takeEvery } from 'redux-saga/effects';

import { initPromoController, showPromo } from './promo.module';
import { PromoSelectors } from './promo.selectors';
import { initDisableAdsBanner } from './sagas/disableAdsBanner';
import { initTopBanner } from './sagas/topBanner.saga';

const PROMO_SHOW_PERIOD = 60 * 1000;

function* handleInitPromoController() {
    const storage = yield select(getCurrentStorage);

    if (
        IS_AUTO_TEST_HIDE ||
        IS_PHONE_BROWSER ||
        (!IS_REACT_PAGE && !(storage === EStorageType.attaches || storage === EStorageType.home || storage === EStorageType.public))
    ) {
        return;
    }

    try {
        let priority = 0;

        yield initTopBanner(priority++);
        yield initWhatsNewPromo(priority++);
        // tempexp_13536-next-line
        yield initDisableAdsBanner();

        while (true) {
            const queue = yield select(PromoSelectors.getPromoQueue);
            const current = yield select(PromoSelectors.getCurrentPromo);

            if (current === null && queue.length > 0) {
                queue.sort((item1, item2) => item2.priority - item1.priority);
                yield put(showPromo(queue.pop()));
            }

            yield delay(PROMO_SHOW_PERIOD);
        }
    } catch (error) {
        yield cancel();
    }
}

export function* promoRoot() {
    yield takeEvery(initPromoController.toString(), handleInitPromoController);
}
